import React, { PropsWithChildren } from "react";
import { Popover } from "@headlessui/react";
import clsx from "clsx";

type TooltipProps = {
  className?: string;
};

const Tooltip = (props: PropsWithChildren<TooltipProps>) => {
  return (
    <Popover className={clsx("relative w-fit", props.className)}>
      <Popover.Overlay className="tablet:bg-opacity-0 fixed inset-0 bg-black bg-opacity-30" />
      {props.children}
    </Popover>
  );
};

export default Tooltip;
